/* ===== CATI Pakistan — Client-Side Video Caching Helper ===== */
export async function setupCachedVideo(videoElement, rawSrc) {
  if (!videoElement || !rawSrc) return;

  videoElement.setAttribute('preload', 'auto');
  videoElement.setAttribute('playsinline', '');
  videoElement.muted = true;
  videoElement.loop = true;
  videoElement.autoplay = true;

  if (!('caches' in window)) {
    if (!videoElement.src) videoElement.src = rawSrc;
    videoElement.play().catch(() => {});
    return;
  }

  const CACHE_NAME = 'cati-hero-video-v1';

  try {
    const cache = await caches.open(CACHE_NAME);
    const cachedResponse = await cache.match(rawSrc);

    if (cachedResponse) {
      const blob = await cachedResponse.blob();
      const objectUrl = URL.createObjectURL(blob);
      videoElement.src = objectUrl;
      videoElement.play().catch(() => {});
      return;
    }

    if (!videoElement.src) videoElement.src = rawSrc;
    videoElement.play().catch(() => {});

    fetch(rawSrc)
      .then(res => {
        if (res.ok && (res.status === 200 || res.status === 206)) {
          cache.put(rawSrc, res);
        }
      })
      .catch(() => {});

  } catch (e) {
    if (!videoElement.src) videoElement.src = rawSrc;
    videoElement.play().catch(() => {});
  }
}
